export default "__VITE_ASSET__1de167d1__"